import React, { Fragment, useEffect, useRef } from 'react';

// Components
import { Modal } from 'app-components';
import CustomFieldForm from '../forms/CustomFieldForm';

// Hooks
import { useTrapFocus } from '@hooks/useTrapFocus';

const FOCUSABLE_SELECTOR =
    'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])';

const CustomFieldModal = (props) => {
    const {
        modalData,
        modalData: {
            headerText,
            onClose
        },
        isDuplicate
    } = props;

    const modalRef = useRef(null);
    const previouslyFocusedElementRef = useRef(null);

    useTrapFocus({ modalRef });

    useEffect(() => {
        previouslyFocusedElementRef.current = document.activeElement;

        const focusTimer = window.setTimeout(() => {
            const container = modalRef.current;
            if (!container) return;
            const firstFocusable = container.querySelector(FOCUSABLE_SELECTOR);
            (firstFocusable ?? container).focus();
        }, 0);

        return () => {
            window.clearTimeout(focusTimer);
            const previouslyFocused = previouslyFocusedElementRef.current;
            if (previouslyFocused && typeof previouslyFocused.focus === 'function' && document.body.contains(previouslyFocused)) {
                previouslyFocused.focus();
            }
            previouslyFocusedElementRef.current = null;
        };
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            onClose?.(e);
        }
    };

    return (
        <Fragment>
            <Modal id='custom_field_modal'>
                <div ref={modalRef} onKeyDown={handleKeyDown} tabIndex={-1}>
                    <Modal.Header id='custom_field_modal_title' titleId={headerText} onHide={onClose} />
                    <Modal.Body>
                        <CustomFieldForm {...{ ...modalData, isDuplicate, onCancelHandler: onClose }} />
                    </Modal.Body>
                </div>
            </Modal>
        </Fragment>
    );
};

export default CustomFieldModal;
